import { UPDATE_USER_DATA } from '../constants';

export function updateUserData(data) {
  return {
    data,
    type: UPDATE_USER_DATA,
  };
}
